<template>
    <div class="chart-analytics-correctness-mode">
        <div class="chart-analytics-correctness-mode__header">
            <span class="chart-analytics-correctness-mode__header-icon"></span>
            <div class="chart-analytics-correctness-mode__heading">
                <span class="chart-analytics-correctness-mode__heading-period">{{ textHeadingPeriod }}</span>
                <span class="chart-analytics-correctness-mode__heading-text">Doğruluk Karşılaştırması</span>
            </div>
        </div>
        <div class="chart-analytics-correctness-mode__wr-chart">
            <div
                v-if="showPreloader"
                class="chart-analytics-correctness-mode__preloader"></div>
            <canvas
                v-if="!showPreloader"
                id="chart-analytics-correctness-mode__chart"></canvas>
        </div>
        <div
            v-if="!showPreloader"
            class="chart-analytics-correctness-mode__legend">
            <div class="chart-analytics-correctness-mode__legend-item chart-analytics-correctness-mode__legend-item--phonemic-vowel">
                <span class="chart-analytics-correctness-mode__legend-item-icon"></span>
                <span class="chart-analytics-correctness-mode__legend-item-text">ünlü özellikleri</span>
            </div>
            <div class="chart-analytics-correctness-mode__legend-item chart-analytics-correctness-mode__legend-item--phonemic-consonant">
                <span class="chart-analytics-correctness-mode__legend-item-icon"></span>
                <span class="chart-analytics-correctness-mode__legend-item-text">ünsüz özellikleri</span>
            </div>
            <div class="chart-analytics-correctness-mode__legend-item chart-analytics-correctness-mode__legend-item--phonetic-vowel">
                <span class="chart-analytics-correctness-mode__legend-item-icon"></span>
                <span class="chart-analytics-correctness-mode__legend-item-text">ünlü değişkeleri</span>
            </div>
            <div class="chart-analytics-correctness-mode__legend-item chart-analytics-correctness-mode__legend-item--phonetic-consonant">
                <span class="chart-analytics-correctness-mode__legend-item-icon"></span>
                <span class="chart-analytics-correctness-mode__legend-item-text">ünsüz değişkeleri</span>
            </div>
        </div>
    </div>
</template>
<script>
    import Chart from 'chart.js/auto';
    let chartInstance = null;

    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            filteredChartCorrectnessModeData(){
                if(this.showPreloader){
                    return null;
                }
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessMode.type;
                return this.$store.state.response.analyticsCorrectness.chartCorrectnessModeData[selectedFiltertagType];
            },

            textHeadingPeriod(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsCorrectness.correctnessMode.type;
                if(selectedFiltertagType === 'last20'){
                    return 'SON 20';
                }
                else if(selectedFiltertagType === 'last100'){
                    return 'SON 100';
                }
            }
        },

        watch: {
            filteredChartCorrectnessModeData: {
                handler(nv, ov){
                    if(!this.filteredChartCorrectnessModeData){
                        return;
                    }
                    if(!chartInstance){
                        return;
                    }
                    this.$nextTick(() => {
                        chartInstance.destroy();
                        this.createChart();
                    });
                },
                deep: true
            },
        },

        methods: {
            createChart(){
                Chart.defaults.font.family = 'Overpass';
                chartInstance = new Chart(document.querySelector('#chart-analytics-correctness-mode__chart'), {
                    type: 'bar',
                    data: {
                        labels: this.filteredChartCorrectnessModeData.labels,
                        datasets: [{
                            data: this.filteredChartCorrectnessModeData.data,
                            barThickness: 22,
                            backgroundColor: ['#FDD9CC', '#E1DDDE', '#C2E6C6', '#F0E1AA'],
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                border: {
                                    color: '#D9D9D9'
                                },
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    display: false,
                                },
                                title: {
                                    display: true,
                                    text: 'Pratik Modu',
                                    color: '#666666',
                                    font: {
                                        size: 11
                                    }
                                },
                            },
                            y: {
                                border: {
                                    display: false,
                                },
                                grid: {
                                    color: '#D9D9D9'
                                },
                                ticks: {
                                    color: '#666666',
                                    font: {
                                        size: 11,
                                    },
                                    stepSize: 10,
                                    callback: tickValue => '%' + tickValue,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                display: false,
                            },
                            tooltip: {
                                callbacks: {
                                    label: tooltipItem => 'doğruluk %' + tooltipItem.formattedValue
                                }
                            }
                        }
                    }
                });
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsChartCorrectnessMode)
                .then(response => response.json())
                .then(chartCorrectnessModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'chartCorrectnessModeData',
                        data: chartCorrectnessModeData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    });
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsCorrectnessChartCorrectnessMode, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(chartCorrectnessModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsCorrectness',
                        dataLabel: 'chartCorrectnessModeData',
                        data: chartCorrectnessModeData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    });
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                })
            }
        }
    };
</script>
<style scoped src="@/css/components/chart-analytics-correctness-mode.css"></style>